import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const workflowActionStep = defineStepConfig({
  type: "workflow_action",
  name: "Workflow Action",
  description:
    "Executes a reusable workflow action as a child workflow. Sockets mirror the selected action's public interface.",
  category: "Control Flow",
  inputSchema: z.record(z.string(), z.unknown()),
  outputSchema: z.record(z.string(), z.unknown()),
  configSchema: z.object({
    // Lineage id of the reusable workflow. When set without a
    // workflowDefinitionId, the action tracks the latest published version.
    workflowId: z
      .string()
      .uuid()
      .optional()
      .describe("Reusable workflow lineage to execute"),
    // A specific version to pin to. Null/absent (with workflowId set) means
    // "latest published", resolved at runtime via the pinned version.
    workflowDefinitionId: z
      .string()
      .uuid()
      .nullable()
      .optional()
      .describe(
        "Specific workflow version to execute (null = latest published)",
      ),
  }),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "10 minutes",
  },
});
